export default {"src":"/_next/static/media/GradingReport.c679b1d1.svg","height":24,"width":24};